import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { HelperService } from './../../services/helper.service';
import { AuthService } from './../../services/auth.service';
import { CollaboratorService } from './../../rest/api/collaborator.service';

@Component({
  selector: 'app-verify-collaborator',
  templateUrl: './verify-collaborator.component.html',
  styleUrls: ['./verify-collaborator.component.scss']
})
export class VerifyCollaboratorComponent implements OnInit {
  isLoading = false;
  registerType: any;
  errMessage: any;
  token: any;
  tokenData: any;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public collaboratorService: CollaboratorService,
    public helperService: HelperService,
    public authService: AuthService,
  ) { }

  ngOnInit() {
    this.authService.removeLocalStorage();
    this.route.params.subscribe(params => {
      if (!params.id) {
        this.router.navigate(['/']);
      }
      this.token = params.id;
      const thisobject = this;
      this.collaboratorService.verifyCollaborator(this.token).subscribe((response: any) => {
        thisobject.tokenData = response && response.data ? response.data : undefined;
        if (thisobject.tokenData && thisobject.tokenData && thisobject.tokenData.member_exists) {
          thisobject.registerType = 'login';
        } else if (thisobject.tokenData && !thisobject.tokenData.member_exists) {
          thisobject.registerType = 'register';
        } else {
          thisobject.errMessage = 'Invalid token or token has expired.';
          setTimeout(() => {
            thisobject.router.navigate(['/']);
          }, 5000);
        }
        thisobject.isLoading = false;
      }, err => {
        thisobject.errMessage = err.error && err.error.message ? err.error.message : 'Invalid token or token has expired.';
        setTimeout(() => {
          thisobject.router.navigate(['/']);
        }, 5000);
      });
    });

  }

}
